<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Numeracja',
              modelPath: [this, 'form', 'numeration'],
              required: true
            }),
            new fields.Input({
              label: 'Nagłówek',
              modelPath: [this, 'form', 'header'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              modelPath: [this, 'form', 'text'],
              multilingual: true,
              required: true
            }),
            new fields.Image({
              label: 'Pierwsza grafika',
              modelPath: [this, 'form', 'first_image'],
              multilingual: true
            }),
            new fields.Image({
              label: 'Druga grafika',
              modelPath: [this, 'form', 'second_image'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Tytuł menu bocznego',
              modelPath: [this, 'form', 'sided_menu_title'],
              multilingual: true
            }),
            new fields.Switch({
              label: 'Pełna szerokość diviera',
              modelPath: [this, 'form', 'is_full_width_divider']
            })
          ]
        }
      ]
    }
  }
}
</script>
